import React from 'react';
import PropTypes from 'prop-types';
import { useSession } from 'next-auth/react';
import { FlagshipProvider } from '@flagship.io/react-sdk';
import { shared } from '../config';

export const ExperimentProvider = ({ children }) => {
  const { data: session } = useSession();
  let id = session?.user?.id ?? null;
  if (id) id += '';
  const visitorData = session?.user?.id
    ? {
        id,
        context: {
          // some context
        },
        isAuthenticated: !!session.user.id,
      }
    : {
        isAuthenticated: false,
        id: null,
      };
  return (
    <FlagshipProvider
      envId={shared.FLAGSHIP_ENV_ID}
      apiKey={shared.FLAGSHIP_API_KEY}
      visitorData={visitorData}
    >
      {children}
    </FlagshipProvider>
  );
};

ExperimentProvider.displayName = 'ExperimentProvider';

ExperimentProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
